
export const headerImg = 'https://ai-v2.deepcity.cn//default/head.png';
// export const merchantGuid = 'e108201b02ae42e686bcc4c302cbbd11';
